import i18n from '@/utils/i18n';
import React from 'react';
import { PageContainer } from '@/components/page-container';
import { partnerSupplier } from '@/utils/environment';
import { ScrollView } from 'react-native-gesture-handler';
import { SnapPeasCard } from '@/components/snap-peas-card';
import { StyleSheet, Text } from 'react-native';
import { TYPOGRAPHY } from '@/styles';
import { useSignOut } from '@/hooks/use-sign-out';

export const NotAuthorizedScreen: React.FC = () => {
  const signOut = useSignOut();

  return (
    <PageContainer
      containerStyle={styles.container}
      showNavigationHeader={false}
    >
      <ScrollView
        alwaysBounceVertical={false}
        contentContainerStyle={styles.scrollViewContent}
      >
        <SnapPeasCard
          buttonProps={{
            children: i18n.t('log_out'),
            onPress: async () => {
              // AuthContext listens to sign out events and updates the
              // navigation stack to display the AuthStack
              await signOut();
            },
            trackingData: {
              name: 'not_authorized_card.log_out_button',
            },
          }}
        >
          <Text style={TYPOGRAPHY.cardMessageText}>
            {i18n.t('not_authorized_message', {
              supplierName: partnerSupplier.fullName,
            })}
          </Text>
        </SnapPeasCard>
      </ScrollView>
    </PageContainer>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingTop: 0,
  },
  scrollViewContent: {
    // Set flexGrow so it can still scroll when it overflows its container
    flexGrow: 1,
    justifyContent: 'center',
  },
});
